import {
    GetPrFilterKeywordListItemRequest,
    PatchPrFilterKeywordRequest,
    PostPrFilterKeywordRequest,
} from '@finance-lab/utils/types'
import ApiBase from './Api'

const PR_INPUTS_API_PATHS = {
    PR_FILTER_KEYWORDS: '/admin/prfilterkeywords',
}

class PRFilterKeywordsApi extends ApiBase {
    async findAllFilterKeywords() {
        const response = await this._getRequest<GetPrFilterKeywordListItemRequest>(
            PR_INPUTS_API_PATHS.PR_FILTER_KEYWORDS,
        )

        return response
    }

    async createFilterKeyword(keyword: PostPrFilterKeywordRequest['Body']) {
        const response = await this._postRequest<PostPrFilterKeywordRequest>(
            PR_INPUTS_API_PATHS.PR_FILTER_KEYWORDS,
            keyword,
        )

        return response
    }

    async updateFilterKeyword({ id, ...keywordToUpdate }: PatchPrFilterKeywordRequest['Body'] & { id: string }) {
        const response = await this._patchRequest<PatchPrFilterKeywordRequest>(
            PR_INPUTS_API_PATHS.PR_FILTER_KEYWORDS + '/' + id,
            keywordToUpdate,
        )

        return response
    }

    async deleteFilterKeyword(id: string): Promise<{ message: string }> {
        const response = (await this._deleteRequest(PR_INPUTS_API_PATHS.PR_FILTER_KEYWORDS + '/' + id)) as {
            message: string
        }

        return response
    }
}

export default PRFilterKeywordsApi
